module.exports = __webpack_public_path__ + "static/media/nyskyline.b74456ec.jpg";